export default "__VITE_ASSET__DU81qizj__"